import { useGetBalances } from "~/v2/api/hooks/useGetBalances";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { useAccountBalancesCardController } from "./AccountBalancesCard.controller";
import { AccountBalancesCardPresentation } from "./AccountBalancesCard.pres";

export const AccountBalancesCard = () => {
  const { currentAccount, product } = useAccountContext();
  const accountID = currentAccount?.id;
  const isAccountReady = Boolean(accountID && product);

  const { data, isLoading, isError } = useGetBalances({
    accountID: accountID ?? "",
    paper: product === "paper",
    options: {
      enabled: isAccountReady,
      meta: { showErrorToast: false },
    },
  });

  const margin = data?.current ?? undefined;
  const { sections } = useAccountBalancesCardController({ margin });

  return (
    <AccountBalancesCardPresentation
      accountId={currentAccount?.account_number ?? accountID ?? "—"}
      sections={sections}
      isLoading={isAccountReady && isLoading}
      hasError={isError}
    />
  );
};
